import { I18nextProvider } from 'react-i18next';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import { ProtectedRoute } from './components/auth/ProtectedRoute';
import ErrorBoundary from './components/layout/ErrorBoundary';
import { Layout } from './components/layout/Layout';
import i18n from './lib/i18n';
import { AuthPage } from './pages/AuthPage';
import { BookingPage } from './pages/BookingPage';
import { DashboardPage } from './pages/DashboardPage';
import { DocumentChecklistPage } from './pages/DocumentChecklistPage';
import { EmailPreferencesPage } from './pages/EmailPreferencesPage';
import { JobDetailPage } from './pages/JobDetailPage';
import { JobListingsPage } from './pages/JobListingsPage';
import { LandingPage } from './pages/LandingPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PreviewPage } from './pages/PreviewPage';
import { SuccessPage } from './pages/SuccessPage';
import { VideoInterviewPage } from './pages/VideoInterviewPage';
import { WizardPage } from './pages/WizardPage';

function App() {
  return (
    <ErrorBoundary
      title={i18n.t('errors.boundary.title')}
      description={i18n.t('errors.boundary.description')}
      reloadLabel={i18n.t('errors.boundary.reload')}
      showErrorDetails={import.meta.env.DEV}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path='/' element={<LandingPage />} />
              <Route path='/auth' element={<AuthPage />} />
              <Route path='/jobs' element={<JobListingsPage />} />
              <Route path='/jobs/:id' element={<JobDetailPage />} />
              <Route path='/wizard' element={<WizardPage />} />
              <Route
                path='/preview'
                element={
                  <ProtectedRoute>
                    <PreviewPage />
                  </ProtectedRoute>
                }
              />
              <Route path='/success' element={<SuccessPage />} />
              <Route path='/booking/:token' element={<BookingPage />} />
              <Route path='/email-preferences' element={<EmailPreferencesPage />} />
              <Route
                path='/dashboard'
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/documents'
                element={
                  <ProtectedRoute>
                    <DocumentChecklistPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/video'
                element={
                  <ProtectedRoute>
                    <VideoInterviewPage />
                  </ProtectedRoute>
                }
              />
              <Route path='*' element={<NotFoundPage />} />
            </Routes>
          </Layout>
          <Toaster position='top-right' richColors />
        </BrowserRouter>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;
